import PropTypes from 'prop-types';
import React, { Component } from 'react';
import JobGrade from 'ps-components/Modules/AddJob/JobGrade';
import AddJobStructureList from 'ps-components/Modules/AddJob/AddJobStructureList.js';
import AddJobGradeRangeChart from 'ps-components/Modules/AddJob/AddJobGradeRangeChart';

export default class GradeContainer extends Component {
  static propTypes = {
    addJob: PropTypes.object,
    saveJob: PropTypes.func,
    saveJobGrade: PropTypes.func,
    updatePayReport: PropTypes.func,
    getMarketRateChart: PropTypes.func,
    changePayStructure: PropTypes.func,
    addJobStructureList: PropTypes.object,
    history: PropTypes.object,
    marketRateChart: PropTypes.object,
    marketBaseSalary50th: PropTypes.number
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      addJob,
      saveJob,
      saveJobGrade,
      updatePayReport,
      getMarketRateChart,
      changePayStructure,
      addJobStructureList,
      history,
      marketRateChart
    } = this.props;

    const marketBase50th = this.props.marketBaseSalary50th;

    if (addJob.formSections.jobGrade.display && addJobStructureList && marketRateChart) {
      const gradeChartHeight = 390;
      const gradeChartWidth = 950;
      const chartTitle = '';
      const getGradeChart = getMarketRateChart;
      const saveGradeStructure = changePayStructure;
      const structureListChange = function structureListChange(options) {
        getGradeChart(options);
        saveGradeStructure(options);
      };

      let makeJobGradeRangeChart = false;

      // Warning icon if there are too many structures to be displayed.
      let JobGradeRangeChart;

      if (
        marketRateChart &&
        marketRateChart.highChartsJson &&
        marketRateChart.highChartsJson.xAxis &&
        marketRateChart.highChartsJson.xAxis.categories
      ) {
        if (marketRateChart.highChartsJson.xAxis.categories.length > 50) {
          // Only render the warning if there are
          JobGradeRangeChart = (
            <div className="structure--warning">
              <i className="fa fa-exclamation-triangle structure-warning--icon" aria-hidden="true" />
              <span className="structure-warning--text">Number of grades in this structure exceeds 50</span>
            </div>
          );
        }

        if (marketRateChart.highChartsJson.xAxis.categories.length <= 50) {
          // Only render this is there are up to 50 structures.
          // Performance issue, so don't want to render at all.
          JobGradeRangeChart = (
            <AddJobGradeRangeChart
              marketRateChart={marketRateChart}
              getMarketRateChart={getMarketRateChart}
              marketRateChartHeight={gradeChartHeight}
              chartTitle={chartTitle}
              marketRateChartWidth={gradeChartWidth}
              structureList={addJobStructureList}
              structureListChange={structureListChange}
              history={history}
              marketBase50th={marketBase50th}
              saveJobGrade={saveJobGrade}
              jobGrade={this.props.addJob.jobGrade}
              payStructure={this.props.addJob.payStructure}
              recommendGrade={this.props.addJob.recommendGrade}
            />
          );
        }
      }

      return (
        <JobGrade addJob={addJob} saveJob={saveJob} saveJobGrade={saveJobGrade} updatePayReport={updatePayReport}>
          <AddJobStructureList
            structureList={addJobStructureList}
            structureListChange={structureListChange}
            payStructure={addJob.payStructure}
            history={history}
          />

          {JobGradeRangeChart}
        </JobGrade>
      );
    } else {
      return null;
    }
  }
}
